import { FilterRow } from "@components/FilterTag/FilterTag";
import { Checkbox, LoadingSkeleton } from "@narmi/design_system";
import { $staffApi } from "../../../api";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { ThreadQuery } from "../types";

export function RequestTypeTag({
  filters,
  isExpanded,
  close,
  open,
  setFilters,
}: {
  filters: ThreadQuery;
  isExpanded: boolean;
  close: () => void;
  open: () => void;
  setFilters: Dispatch<SetStateAction<ThreadQuery>>;
}) {
  const { data: requestTypesData, isLoading } = $staffApi.useQuery(
    "get",
    "/api/thread_categories/"
  );

  const [requestTypeFilters, setRequestTypeFilters] = useState<string[]>(filters.category);

  useEffect(() => {
    setRequestTypeFilters(filters.category);
  }, [isExpanded, filters.category]);

  return (
    <FilterRow.Tag
      label="Request type"
      countApplied={filters.category.length}
      isExpanded={isExpanded}
      onPopoverDismiss={() => close()}
      onToggle={() => open()}
    >
      <FilterRow.FormContainer>
        <LoadingSkeleton isLoading={!requestTypesData || isLoading}>
          {requestTypesData &&
            requestTypesData.results.map((requestType) => (
              <Checkbox
                key={requestType.uuid}
                label={requestType.name}
                checked={requestTypeFilters.includes(requestType.uuid!)}
                onChange={() => {
                  const isChecked = requestTypeFilters.includes(requestType.uuid!);
                  const newFilters = isChecked
                    ? requestTypeFilters.filter((filter) => filter !== requestType.uuid!)
                    : [...requestTypeFilters, requestType.uuid!];

                  setRequestTypeFilters(newFilters);
                }}
              />
            ))}
          <Checkbox
            label="No request type"
            checked={requestTypeFilters.includes("unassigned")}
            onChange={() => {
              const isChecked = requestTypeFilters.includes("unassigned");
              const newFilters = isChecked
                ? requestTypeFilters.filter((filter) => filter !== "unassigned")
                : [...requestTypeFilters, "unassigned"];
              setRequestTypeFilters(newFilters);
            }}
          />
          {requestTypesData && !requestTypesData.results.length ? (
            <FilterRow.NoResultsFound />
          ) : null}
        </LoadingSkeleton>
      </FilterRow.FormContainer>
      <FilterRow.ActionBar
        onClear={() => {
          setRequestTypeFilters([]);
          setFilters((prev) => ({
            ...prev,
            category: [],
            offset: 0,
          }));
          close();
        }}
        onApply={() => {
          setFilters((prev) => ({
            ...prev,
            category: requestTypeFilters,
            offset: 0,
          }));
          close();
        }}
      />
    </FilterRow.Tag>
  );
}
